export default "__VITE_ASSET__CpHCquze__"